// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qQN_","rootMobile":"styles_rootMobile__1mkB9"};